module.exports = __webpack_public_path__ + "img/diorAddict3.ade11d6e.jpg";